export default ({ request }) => ({
  ecomAmzReplenishmentReplyBackApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/replyBack',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplyDataApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/data',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplyOptionsApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/options',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplyListApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplySaveApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplyAutoReplenishmentApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/auto/replenishment',
      method: 'POST',
      data,
      timeout: 1000 * 60,
    })
  },
  ecomAmzReplenishmentDetailReplyReplenishmentApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/replenishment',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplyOutStockApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/outStock',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplyOutStockBatchApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/outStockBatch',
      method: 'POST',
      data
    })
  },
  ecomAmzReplenishmentDetailReplyOutSubmitApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/submit',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplyOutConfirmApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/confirm',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailReplyOutRejectApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/reply/reject',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailNotReplenishApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/notReplenish',
      method: 'POST',
      data,
    })
  },
})
